"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Backbone layout which serves as a container for other layouts.
 *
 * ## Field
 * Name | Description
 * --- | ---
 * actions | The `ActionContainerView` associated with this layout.
 * @module app/views/Layouts/Base
 */
var ActionContainerView_1 = require("../../views/ActionContainerView");
var React = require("react");
var Wide_1 = require("./Wide");
var NoMenu_1 = require("./NoMenu");
var BaseLayout = /** @class */ (function (_super) {
    __extends(BaseLayout, _super);
    function BaseLayout(props) {
        return _super.call(this, props) || this;
    }
    BaseLayout.prototype.name = function () {
        return this.props.layoutName;
    };
    BaseLayout.prototype.className = function () {
        var props = this.props;
        return [
            "container-" +
                (props.layoutName == NoMenu_1.default.layoutName
                    ? NoMenu_1.default.identifierClass
                    : Wide_1.default.identifierClass),
        ].join(" ");
    };
    BaseLayout.prototype.content = function () {
        var props = this.props;
        if (props.layoutName == NoMenu_1.default.layoutName) {
            return React.createElement(NoMenu_1.default, { view: props.view, app: props.app });
        }
        else {
            return React.createElement(Wide_1.default, { view: props.view, app: props.app });
        }
    };
    BaseLayout.prototype.render = function () {
        var props = this.props;
        // the actual inside should be {(this.props as any).children}
        return (React.createElement("div", { className: this.className() },
            React.createElement(ActionContainerView_1.default, { left: props.left, right: props.right }),
            React.createElement("div", { className: "container" }, this.content())));
    };
    return BaseLayout;
}(React.Component));
exports.default = BaseLayout;
//# sourceMappingURL=Base.js.map


//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/layouts/Base.js
// module id = 670
// module chunks = 1